import DateFormat from 'constants/date_format';

export function formatDateRange(start, end, format = DateFormat.SHORT) {
  const range = [start, end]
    .filter(Boolean)
    .map(date => moment(date).format(format));

  if (range.length === 1) {
    if (start && !end) {
      return t('insights.filters.from_date', { date: range[0] });
    }
    if (!start && end) {
      return t('insights.filters.to_date', { date: range[0] });
    }
  }

  return range.join('–');
}

const DateRangeFormat = ({ start, end, format }) =>
  formatDateRange(start, end, format);

DateRangeFormat.defaultProps = {
  format: DateFormat.SHORT,
};

export default DateRangeFormat;
